import { render, staticRenderFns } from "./EditPageSabreRemarkPerson.vue?vue&type=template&id=bca26d34"
import script from "./EditPageSabreRemarkPerson.vue?vue&type=script&lang=js"
export * from "./EditPageSabreRemarkPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports